import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IssuableCouponType } from '../../@types/coupon';
import { getIssuableCoupon, postCouponNoDownload, postProductNoDownload } from '../../api/coupons';
import { useMyContext } from '../../components/provider/MyProvider';
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation';
import { plusComma } from '../../js/script';

interface PropsType {
  headerText: string;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectProductNo: string | undefined;
  setCheckDown: React.Dispatch<React.SetStateAction<boolean>>;
  setCouponCheck: React.Dispatch<React.SetStateAction<boolean>>;
  downloadable: any;
}

/**
 * 모달 팝업 - 아래 꽉참
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

const imgURL = '/images';

export default function ProductCouponModal({
  setCouponCheck,
  headerText,
  setIsModal,
  selectProductNo,
  downloadable,
}: PropsType) {
  const [closing, setClosing] = useState<boolean>(false); // 닫힘 애니메이션 적용에 필요
  const [item, setItem] = useState<IssuableCouponType[]>([]);
  const [downloadCheck, setDownloadCheck] = useState<boolean>(false);
  const [selectItem, setSelectItem] = useState<number | boolean>(false);
  const { setToastMessage, setToastEvent, setIsToast } = useMyContext();
  const navigate = useNavigate();

  const closeModal = () => {
    setClosing(true);
    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 300);
  };
  //발급 가능한 쿠폰
  useEffect(() => {
    if (selectProductNo !== undefined) {
      getIssuableCoupon(selectProductNo)
        .then((res) => {
          const filteredCoupons = res.data.filter((el: any) => el.couponName !== '어바웃피싱 페이 감사 쿠폰');
          setItem(filteredCoupons);
        })
        .catch((err) => console.log(err));
    }
  }, [selectProductNo, downloadCheck]);

  function downloadCoupon(couponNo: number) {
    postCouponNoDownload(couponNo)
      .then((res) => {
        setDownloadCheck((prev: any) => !prev);
        setCouponCheck((prev: any) => !prev);
      })
      .catch((err) => console.log(err));
  }

  function allCouponDownload(productNo: string) {
    postProductNoDownload(productNo)
      .then((res) => {
        setDownloadCheck((prev: any) => !prev);
        setCouponCheck((prev: any) => !prev);
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    if (downloadable.length === 0) {
      closeModal();
    }
  }, [downloadable]);

  useEffect(() => {
    if (downloadCheck) {
      setIsToast(true);
      setToastMessage('쿠폰이 발급되었습니다.');
      setToastEvent(() => () => navigate('/mycoupon'));
      setTimeout(() => {
        setDownloadCheck(false);
      }, 3000);
    }
  }, [downloadCheck]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    const sort = [...item];
    if (item) {
      sort.sort((a: any, b: any) => {
        return a.discountAmt - b.discountAmt;
      });
    }
  }, [item]);

  // if (!isModal) return null;
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <ModalTitle>{headerText}</ModalTitle>
          <button className="btn_close" onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt="닫기" />
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="product_coupon_modal">
            {item.map((el: any, index: number) => {
              if (el.downloadable) {
                return (
                  <>
                    <button
                      className="coupon_item"
                      key={el.couponNo}
                      onClick={() => {
                        if (index === selectItem) {
                          setSelectItem(false);
                        } else {
                          setSelectItem(index);
                        }
                      }}
                    >
                      <div className="f_box">
                        <div className="coupon_info_wrap">
                          <div className="coupon_title">{el.couponName}</div>
                          <div className="coupon_desc">
                            최대{' '}
                            {!el.discountInfo?.discountRate
                              ? `${plusComma(el.discountInfo?.discountAmt)}원 할인`
                              : `${plusComma(el.discountInfo?.maxDiscountAmt)}원 할인`}
                          </div>
                          <div className="coupon_benefit">
                            {el.discountInfo?.discountRate
                              ? `${el.discountInfo?.discountRate}%`
                              : `${plusComma(el.discountInfo?.discountAmt)}원`}
                          </div>
                        </div>

                        {el.downloadable ? (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadCoupon(el.couponNo);
                            }}
                            key={el.couponNo}
                          >
                            <span>쿠폰 발급</span>
                          </button>
                        ) : (
                          <button type="button" className="off" key={el.couponNo}>
                            <span>쿠폰 발급</span>
                          </button>
                        )}
                      </div>
                    </button>
                  </>
                );
              }
            })}
          </div>
        </ModalBody>
        {/* {selectOption.length !== 0 && (
          <PriceWrap>
            <p
              style={{
                fontSize: '16px',
                lineHeight: '24px',
                color: 'var(--colGray6)',
              }}
            >
              총 상품금액
            </p>
            <p
              style={{
                fontSize: '18px',
                lineHeight: '24px',
                fontWeight: 'bold',
              }}
            >
              {plusComma(allPrice)}원
            </p>
          </PriceWrap>
        )} */}
        <ModalFooter>
          <button
            className="product_coupon_download_all"
            onClick={() => {
              if (selectProductNo !== undefined) {
                allCouponDownload(selectProductNo);
              }
            }}
          >
            전체 쿠폰 다운받기
          </button>
        </ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}

interface typeProps {
  closing?: boolean;
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;
`;

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;
  padding: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18.5px 22px 0 33px;
  & button.btn_close {
    width: 41px;
    height: 48px;
    padding: 12px 8px 12px 9px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 8px 33px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 33px;
`;

export const CartBtnLeft = styled.span`
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  background: var(--colWhite);
  padding: 12px 0;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  width: 100%;
  font-weight: 500;
`;

export const CartBtnRight = styled.span`
  font-size: 14px;
  line-height: 24px;
  padding: 12px 0;
  text-align: center;
  background: #000;
  border-radius: 5px;
  width: 100%;
  color: var(--colWhite);
  font-weight: 500;
`;

export const ModalTitle = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
`;

export const SelectBox = styled.div<{ show: boolean }>`
  position: relative;
  width: 100%;
  padding: 0px;
  background-color: var(--colWhite);
  border: ${(props) => (props.show ? '1px solid var(--colBlack)' : '1px solid #e0e0e0')};
  border-radius: 6px;
  align-self: center;
  cursor: pointer;
`;
export const Label = styled.label`
  font-size: 15px;
  line-height: 16px;
  text-align: center;
  font-weight: 600;
`;

export const LabelWrap = styled.div<{ show: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  border-bottom: ${(props) => (props.show ? '1px solid #e0e0e0' : null)};
`;

export const SelectOptions = styled.ul<{ show: boolean }>`
  height: 207px;
  overflow: scroll;
  list-style: none;
  width: 100%;
  max-height: ${(props) => (props.show ? 'none' : '0')};
  padding: 0;
  border-radius: 8px;
  background-color: var(--colWhite);
  color: #000;
`;

export const Option = styled.li`
  font-size: 15px;
  line-height: 16px;
  font-weight: 600;
  padding: 15px 16px;
  transition: background-color 0.2s ease-in;
  &:hover {
    background-color: var(--colWhite);
  }
`;

export const NPay = styled.div`
  width: 100%;
  height: 40px;
  background: #00de5a;
`;

export const OptionBox = styled.div`
  max-height: 228px;
  overflow: scroll;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 0;
`;

export const OptionWrap = styled.div`
  width: 100%;
  background: var(--colGray1);
  border-radius: 10px;
  padding: 15px 16px;
`;

export const OptionContentWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OptionContentContent = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: var(--colGray7);
`;

export const OptionPrice = styled.p`
  font-size: 15px;
  line-height: 16px;
  color: var(--colBlack);
  font-weight: bold;
`;

export const PriceWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
